import { createAsyncReducer } from "@telstra-connect/standard-actions/reducers";
import {
    IAddToCartAction,
    IAddToCartErrorAction,
    IAddToCartSuccessAction,
} from "../actions/add-to-cart/add-to-cart";
import { IStoreIntState } from "../state";
import { initialState } from "../state/initial-state";

export type AddToCartAction =
    | IAddToCartAction
    | IAddToCartErrorAction
    | IAddToCartSuccessAction
const init = (state: IStoreIntState, action: AddToCartAction) => ({
    ...state,
    addToCart: {
        ...state.addToCart,
        status: action.status,
    },
});

const success = (state: IStoreIntState, action: AddToCartAction) => {
    return {
        ...state,
        addToCart: {
            ...state.addToCart,
            status: action.status,
            message: (action as  IAddToCartSuccessAction).data.message,
            code: (action as  IAddToCartSuccessAction).data.code,
            data: (action as  IAddToCartSuccessAction).data,
        },
    };
};

const failure = (state: IStoreIntState, action: AddToCartAction) => ({
    ...state,
    addToCart: {
        ...initialState.addToCart,
        status: action.status,
        error: (action as IAddToCartErrorAction).error,
    },
});

export const addToCart = createAsyncReducer(
    initialState,
    init,
    success,
    failure,
);
